import { useContext } from 'react';

import { ManagementContext } from '@/features/management/manager/utils/ManagementContext';

export const useIsManagementContext = (): boolean => {
  const context = useContext(ManagementContext);
  return !!context && context.initialized;
};
